export enum PORTAL_USERS_KEYS {
  ORGANIZATION_SETTINGS = 'organizationSettings',
  PORTAL_USER = 'portalUser',
}
